<template>
  <v-list-tile>
    <v-list-tile-content>
      <v-list-tile-title class="body-1 font-weight-light">
        {{ title }}
      </v-list-tile-title>
      <v-list-tile-sub-title class="text-lg-right subheading font-weight-bold">
        <AppNumberWithUnit
          :value="value"
          :unit="unit"
          :prefix="prefix"
          :local-string="localString"
          fallback-text="−"
        />
      </v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  name: 'SimulationResultListItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: null,
    },
    unit: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    localString: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
